"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ItemList = function ItemList(_ref) {
  var children = _ref.children,
      expand = _ref.expand;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('navbar-nav', {
      'navbar-nav-expand': expand
    })
  }, children);
};

var _default = ItemList;
exports.default = _default;